import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Snippet,
} from "@heroui/react";

import { showSuccess } from "@/lib/toast";

/**
 * 発行した仮パスワードを**一度だけ**見せるダイアログ。
 *
 * 平文はこの画面でしか得られない（以降はハッシュしか残らない）。閉じると
 * 二度と確認できないことを明示し、コピーできるようにしてある。
 */
export default function TemporaryPasswordDialog({
  isOpen,
  email,
  temporaryPassword,
  expiresAt,
  onClose,
}: {
  isOpen: boolean;
  email: string;
  temporaryPassword: string | null;
  expiresAt: string | null;
  onClose: () => void;
}) {
  return (
    <Modal
      isOpen={isOpen && temporaryPassword != null}
      // 誤って閉じて控え忘れるのを防ぐため、背景クリックや Esc では閉じない。
      isDismissable={false}
      hideCloseButton
      onOpenChange={(open) => !open && onClose()}
      size="lg"
    >
      <ModalContent>
        <ModalHeader className="flex-col items-start gap-1">
          <span>仮パスワードを発行しました</span>
          <span className="text-small font-normal text-default-500">{email}</span>
        </ModalHeader>

        <ModalBody>
          <p className="text-sm">
            本人に渡してください。初回ログイン時にパスワードの変更を求められます。
          </p>
          <Snippet
            symbol=""
            variant="bordered"
            size="lg"
            className="w-full"
            onCopy={() => showSuccess("仮パスワードをコピーしました。")}
          >
            {temporaryPassword ?? ""}
          </Snippet>
          <p className="text-sm text-danger">
            この画面を閉じると二度と確認できません。控えてから閉じてください。
          </p>
          {expiresAt && (
            <p className="text-tiny text-default-500">
              有効期限: {expiresAt.slice(0, 10)}
              （期限が切れた場合は再発行してください）
            </p>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            radius="full"
            data-testid="close-temporary-password"
            onPress={onClose}
          >
            控えました
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
